/*
********************************************************************************
Capacitor-related functions
********************************************************************************
*/

//@ts-nocheck
// Toggle preceding from @ts-nocheck to @ts-check to enable TypeScript checking

import { Storage } from "@ionic/storage";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";
import { consoleMsg } from "./utility.js";
import { mkAbs } from "./page-init.js";

// prettier-ignore
export { 
  viewPhoto, 
};

// Make sure our app references are using the global app object associated with window
const app = window.app;

let store;

async function initStorage() {
	store = new Storage();
	await store.create();
	consoleMsg("Ionic Storage is ready");

	// Assign store to the global window object for access in the console
	window.store = store;
}

initStorage();

const keys = await store.keys();

if (keys.length > 0 && keys.includes("damage-markers")) {
	consoleMsg("Damage markers in Ionic storage...");
	app.state.damageMarkers = await store.get("damage-markers");
} else {
	consoleMsg("DAMAGE MARKERS NOT STORED...");
}

function viewPhoto(photoUrl) {
	// Create the modal container
	const modal = document.createElement("div");
	modal.classList.add("photo-modal"); // Use CSS class for styling

	// Create the image element
	const image = document.createElement("img");
	image.src = photoUrl;
	image.alt = "Full-size photo";
	image.classList.add("photo-modal-image"); // Use CSS class for styling

	// Add the image to the modal
	modal.appendChild(image);

	// Add a click event to close the modal
	modal.addEventListener("click", () => {
		modal.remove();
	});

	// Append the modal to the body
	document.body.appendChild(modal);
}

// Check if the Capacitor object is available
if (Capacitor) {
	consoleMsg("Capacitor object is available.");

	// Check if the app is running on an iOS device
	const platform = Capacitor.getPlatform();
	consoleMsg("Capacitor.getPlatform() returned:", platform);
	const isIOS = platform === "ios";
} else {
	console.error("Capacitor object is not available.");
}

if (Capacitor.isPluginAvailable("StatusBar")) {
	window.addEventListener("statusTap", function () {
		consoleMsg("statusbar tapped");
	});
}
